import { InsuranceCompaniesServiceInterface } from 'domain/services';
import { GetAllInsuranceCompaniesUseCaseInterface } from 'domain/usecases';

interface UseCasesInjection {
  getAllInsuranceCompanies: GetAllInsuranceCompaniesUseCaseInterface;
}

export class InsuranceCompaniesService
  implements InsuranceCompaniesServiceInterface
{
  private readonly _getAllInsuranceCompanies: GetAllInsuranceCompaniesUseCaseInterface;

  constructor(usecases: UseCasesInjection) {
    this._getAllInsuranceCompanies = usecases.getAllInsuranceCompanies;
  }

  getAllInsuranceCompanies(): Promise<GetAllInsuranceCompaniesUseCaseInterface.Result> {
    return this._getAllInsuranceCompanies.execute();
  }
}
